import { render } from "./PageContent.vue?vue&type=template&id=568b99d8&ts=true&lang=html"
import script from "./PageContent.vue?vue&type=script&lang=ts"
export * from "./PageContent.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__